// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__llt5H","content":"styles_content__2v92u","selectAll":"styles_selectAll__3gcjn"};